import type { VoidFunctionComponent } from 'react';
import Pagination from '.';

type Props = {
  //  Current page of visible items
  page: number,
  //  Number of items visible per page
  count: number,
  //  Total number of items available
  totalItems: number,
  //  Function to update the current page
  setPage: (page: number) => void,
};

/**
 * Displays a set of arrows and numbers to enable navigation between
 * pages of items.
 */
const PaginationFooterPage: VoidFunctionComponent<Props> = ({
  page,
  count,
  totalItems,
  setPage,
}) => {
  //  Round up the total # of items / count.
  const pageCount = Math.ceil(totalItems / count);

  //  Don't allow clicking the pagination when there is only one page.
  const isDisabled = pageCount === 1;

  return (
    <div className="fossa-pagination-footer__page">
      <Pagination
        page={page}
        pagesCount={pageCount}
        isDisabled={isDisabled}
        onChange={setPage}
      />
    </div>
  );
};

export default PaginationFooterPage;
